"use strict";

import React from "react";

export function IconEssentials() {
  return (
    <svg width="32" height="32" viewBox="0 0 31.8 31.8">
      <polygon points="23.3 18.9 12.5 14.1 0.1 16.8 0 16.4 0 18.9 " />
      <polygon points="0 8.5 0 15.8 11 13.4 " />
      <polygon points="28 19.9 31.8 21.6 31.8 9.9 14.2 13.8 25.7 18.9 31.8 18.9 31.8 19.9 " />
      <polygon points="0 23.4 0 31.8 31.8 31.8 31.8 27.1 " />
      <polygon points="31.8 4.2 31.8 5.2 0 5.2 0 7.4 12.6 13.1 31.8 8.9 31.8 0 0 0 0 4.2 " />
      <polygon points="31.8 26 31.8 22.7 25.5 19.9 0 19.9 0 22.9 0.1 22.4 " />
    </svg>
  );
}

export function IconMeasures() {
  return (
    <svg width="32" height="32" viewBox="0 0 31.8 31.8">
      <polygon points="30.4 18.7 31.8 18.4 31.8 17.4 27.2 17.1 " />
      <polygon points="24.2 20.4 10.4 21.8 17.3 22.3 " />
      <polygon points="13 9.6 12.7 9.7 19.3 13.1 22.8 13.1 31.8 10.6 31.8 10.6 15.5 9.6 " />
      <polygon points="28.6 19 24.7 17 14.5 16.3 0 20.2 0 21.2 4.3 21.5 " />
      <polygon points="21.8 14.4 25 16 31.8 16.4 31.8 14.1 22.9 14.1 " />
      <polygon points="19.1 14.1 0 14.1 0 14.5 14.4 15.3 " />
      <polygon points="17.1 13.1 11.3 10.1 0.2 13.1 " />
      <polygon points="0 15.5 0 19.2 11.4 16.1 " />
      <polygon points="16.7 8.6 31.8 8.6 31.8 8.1 18.5 8.1 " />
      <polygon points="0 9.6 0 12.1 9.2 9.6 " />
      <polygon points="20.4 14.7 17.5 15.5 22.5 15.8 " />
      <polygon points="31.8 13.1 31.8 11.7 26.6 13.1 " />
      <polygon points="31.8 7.1 31.8 4.6 22.2 7.1 " />
      <polygon points="20.5 22.5 31.8 23.1 31.8 20.6 30.3 19.8 " />
      <polygon points="0 0 0 3.2 7.7 7.1 18.4 7.1 31.8 3.5 31.8 0 " />
      <polygon points="0 28 0 31.8 31.8 31.8 31.8 26.2 6.7 26.2 " />
      <polygon points="10.4 25.2 31.8 25.2 31.8 24.1 17.4 23.3 " />
      <polygon points="0 26.2 0 26.9 2.8 26.2 " />
      <polygon points="14.6 8.1 9.7 8.1 10 8.3 13.4 8.5 " />
      <polygon points="0 4.3 0 7.1 5.6 7.1 " />
      <polygon points="14.3 23.1 4.3 22.5 0 22.9 0 25.2 6.5 25.2 " />
    </svg>
  );
}

export function IconParentSurvey() {
  return (
    <svg width="32" height="32" viewBox="0 0 31.8 31.8">
      <path d="M0,0v31.8h31.8V0H0z M7.4,7.1h19.9v2.1H7.4V7.1z M24.5,16.1c0,1.8-1.4,3.2-3.2,3.2s-3.2-1.4-3.2-3.2c0-1.8,1.4-3.2,3.2-3.2S24.5,14.3,24.5,16.1z M7.4,11.9h11.3c-0.8,0.5-1.5,1.2-1.9,2.1H7.4V11.9z M5.8,18.7H3.6v-2.1h2.1V18.7z M5.8,13.9H3.6v-2.1h2.1V13.9z M5.8,9.2H3.6V7.1h2.1V9.2z M7.4,16.7h9c0.1,0.7,0.3,1.4,0.7,2.1H7.4V16.7z M27.7,25.7H14.9v-1.6c0-2.2,4.2-3.2,6.4-3.2c2.2,0,6.4,1,6.4,3.2V25.7z" />
    </svg>
  );
}

export function IconReconSurvey() {
  // NOTE: this is intentional, we do want the same icon for parent and for recon surveys.
  return <IconParentSurvey />;
}

export function IconBelSurvey() {
  return (
    <svg width="32" height="32" viewBox="413 235.52672 136 136.56489">
      <mask id="bel-icon-mask">
        <rect x="413" y="236" width="136" height="136" fill="white" />
        <line
          x1="458.5"
          y1="237.52672"
          x2="458.5"
          y2="370.0916"
          strokeWidth="4"
          stroke="black"
        />
        <circle cx="458.5" cy="267" r="8" fill="black" />
        <circle cx="458.5" cy="312" r="8" fill="black" />
        <circle cx="458.5" cy="248" r="8" fill="black" />
        <circle cx="458.5" cy="267" r="4.5" fill="white" />
        <circle cx="458.5" cy="312" r="4.5" fill="white" />
        <circle cx="458.5" cy="248" r="4.5" fill="white" />
      </mask>
      <rect
        x="413"
        y="236"
        width="136"
        height="136"
        mask="url(#bel-icon-mask)"
      />
    </svg>
  );
}

export function IconNotes() {
  return (
    <svg width="32" height="32" viewBox="0 0 31.8 31.8">
      <path d="M0 0v31.8h31.8V0H0zM3.6 3.5h24.9v1.2H3.6V3.5zM3.6 7.5h14.6v1.4H3.6V7.5zM28.4 14.3L15.6 27.1c-0.1 0.1-0.2 0.1-0.3 0.1l-4.9 1.6 1.6-4.9c0-0.1 0.1-0.2 0.1-0.3l12.8-12.8c0.1-0.1 0.2-0.1 0.3-0.1 0.1 0 0.2 0 0.3 0.1l2.8 2.8C28.6 13.8 28.6 14.1 28.4 14.3z" />
    </svg>
  );
}

export function GlyphBase({
  width,
  height,
  className = "",
  square,
  backgroundClassName = "",
  children,
}) {
  if (square) {
    let S = typeof square === "number" ? square : 25;
    let P = S / 5;
    let id = "glyph-contents-" + Math.random().toFixed(20).slice(2); // TODO: something stable for DOM diffing!
    return (
      <svg width={S} height={S} className={`svg-glyph ${className}`}>
        <symbol id={id} viewBox={`0 0 ${width} ${height}`}>
          {children}
        </symbol>
        <rect
          className={`background ${backgroundClassName}`}
          x={0}
          y={0}
          width={S}
          height={S}
        />
        <use
          xlinkHref={`#${id}`}
          x={0 + P}
          y={0 + P}
          width={S - 2 * P}
          height={S - 2 * P}
        />
      </svg>
    );
  } else {
    return (
      <svg
        width={width}
        height={height}
        className={`svg-glyph ${className}`}
        viewBox={`0 0 ${width} ${height}`}
      >
        {children}
      </svg>
    );
  }
}

export function GlyphExistingNote() {
  return (
    <GlyphBase width="13" height="15">
      <path d="M0,0v14.8h12.6V0H0z M6.7,9.7H2.2v-1h4.5V9.7z M10.6,7H2.2V6h8.4V7z M10.6,4.2H2.2v-1h8.4V4.2z" />
    </GlyphBase>
  );
}

export function GlyphSharedMeasure() {
  return (
    <GlyphBase width="24" height="24">
      <path d="M16 11c1.66 0 2.99-1.34 2.99-3s-1.33-3-2.99-3c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3s-1.33-3-2.99-3c-1.66 0-3 1.34-3 3s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5v2.5h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45v2.5h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
    </GlyphBase>
  );
}

export function GlyphCollapseToggle() {
  return (
    <GlyphBase width="11" height="6">
      <path d="M10.8 5.4c0 0.2-0.1 0.4-0.2 0.6 -0.2 0.2-0.4 0.2-0.6 0.2C9.8 6.2 7.6 4.1 7.5 4L5.4 1.9 1.3 6C1.2 6.1 1 6.2 0.8 6.2 0.6 6.2 0.4 6.1 0.2 6 0.1 5.8 0 5.6 0 5.4 0 5.2 0.1 5 0.2 4.8l4.6-4.6C5 0.1 5.2 0 5.4 0 5.6 0 5.8 0.1 6 0.2l4.6 4.6C10.7 5 10.8 5.2 10.8 5.4z" />
    </GlyphBase>
  );
}

export function GlyphFilterPerformanceHighest(props) {
  return (
    <GlyphBase {...props} width="8" height="14">
      <polygon points="3.9 2.8 0 7.5 3.5 7.5 3.5 14.1 4.3 14.1 4.3 7.5 7.8 7.5 " />
      <rect width="7.8" height="0.8" />
    </GlyphBase>
  );
}

export function GlyphFilterPerformanceLowest(props) {
  return (
    <GlyphBase {...props} width="8" height="14">
      <polygon points="3.9 11.4 7.8 6.7 4.3 6.7 4.3 0 3.5 0 3.5 6.7 0 6.7 " />
      <rect y="13.3" width="7.8" height="0.8" />
    </GlyphBase>
  );
}

export function GlyphFilterTrendIncrease(props) {
  return (
    <GlyphBase {...props} width="8" height="11">
      <polygon points="2.2 3.1 5 5.8 0 10.8 0.6 11.4 5.6 6.4 8.3 9.2 8.3 3.1 " />
      <rect x="0.4" width="7.8" height="0.8" />
    </GlyphBase>
  );
}

export function GlyphFilterTrendDecrease(props) {
  return (
    <GlyphBase {...props} width="8" height="12">
      <polygon points="5.6 5 0.6 0 0 0.6 5 5.6 2.2 8.3 8.3 8.3 8.3 2.2 " />
      <rect x="0.4" y="10.8" width="7.8" height="0.8" />
    </GlyphBase>
  );
}

export function GlyphRangeOneYear(props) {
  return (
    <GlyphBase {...props} width="4.5" height="4.5" className={"range-one-year"}>
      <circle cx="2.3" cy="2.3" r="2.3" />
    </GlyphBase>
  );
}

export function GlyphRangeTwoYears(props) {
  return (
    <GlyphBase
      {...props}
      width="17.3"
      height="11.8"
      className={"range-two-years"}
    >
      <path d="M15,0c-1.3,0-2.3,1-2.3,2.3c0,0.2,0,0.4,0.1,0.6l-9,5c-0.4-0.4-1-0.6-1.6-0.6C1,7.2,0,8.2,0,9.5s1,2.3,2.3,2.3c1.3,0,2.3-1,2.3-2.3c0-0.3-0.1-0.5-0.1-0.8l8.9-4.9c0.4,0.5,1,0.8,1.7,0.8c1.3,0,2.3-1,2.3-2.3S16.3,0,15,0z" />
    </GlyphBase>
  );
}

export function GlyphRangeAllYears(props) {
  return (
    <GlyphBase {...props} width="20" height="11" className={"range-all-years"}>
      <path d="M17.8,0c-1.3,0-2.3,1-2.3,2.3c0,0.4,0.1,0.8,0.3,1.1l-3.6,2.9c-0.4-0.5-1-0.7-1.7-0.7c-1.3,0-2.3,1-2.3,2.3c0,0,0,0.1,0,0.1L4.5,8.1c-0.3-1-1.1-1.7-2.2-1.7C1,6.4,0,7.5,0,8.7S1,11,2.3,11c1.2,0,2.1-0.9,2.3-2l3.9-0.3C8.8,9.5,9.6,10,10.5,10c1.3,0,2.3-1,2.3-2.3c0-0.3-0.1-0.6-0.2-0.9L16.3,4c0.4,0.3,0.9,0.6,1.5,0.6c1.3,0,2.3-1,2.3-2.3S19,0,17.8,0z" />
    </GlyphBase>
  );
}

export function GlyphScrollDownCaret(props) {
  return (
    <GlyphBase
      {...props}
      width="15"
      height="9.3"
      className={"scroll-down-caret"}
    >
      <path d="M2,0l5.6,5.6L13.1,0L15,1.9L8.6,8.3c-0.3,0.3-1.1,1-1.1,1s-0.8-0.7-1.1-1L0,1.9L2,0z" />
    </GlyphBase>
  );
}

export function GlyphVisit(props) {
  return (
    <GlyphBase {...props} width="9" height="10" className={"visit-arrow"}>
      <path d="M8.77941 1.78033L1.27941 9.28033L0.21875 8.21967L7.71875 0.719674L8.77941 1.78033Z" />
      <path d="M-3.93402e-07 0.5L9 0.5L9 9.5L7.5 9.5L7.5 2L-3.27835e-07 2L-3.93402e-07 0.5Z" />
    </GlyphBase>
  );
}

export function GlyphDownload(props) {
  return (
    <GlyphBase {...props} width="10" height="14" className={"download-arrow"}>
      <path d="M4.23047 9.625L4.23047 0.625L5.73047 0.625L5.73047 9.625L4.23047 9.625Z" />
      <path d="M0.480469 11.875H9.48047V13.375H0.480469V11.875Z" />
      <path d="M0 6.45118L0.960277 5.29884L4.98014 8.64873L9 5.29884L9.96028 6.45118L4.98014 10.6013L0 6.45118Z" />
    </GlyphBase>
  );
}

export function GlyphClose(props) {
  return (
    <GlyphBase {...props} width="10" height="10" className={"close-cross"}>
      <path d="M1 1L9 9" stroke-width="2" />
      <path d="M9 1L1 9" stroke-width="2" />
    </GlyphBase>
  );
}

export function GlyphDirection({ pointing: d, ...props }) {
  const [w, h, x, alt] = {
    up: [9, 6, 0, "Pointing up"],
    dn: [9, 6, 180, "Pointing down"],
  }[d];
  return (
    <GlyphBase {...props} width={w} height={h} className={"direction-arrow"}>
      <title>{alt}</title>
      <path
        transform-origin="50% 50%"
        transform={`rotate(${x})`}
        d="M4.31814 0L0.318176 6H8.31818L4.31814 0Z"
      />
    </GlyphBase>
  );
}
